import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RedirectForbidden: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/forbidden');
  }, [navigate]);

  return null;
};

export default RedirectForbidden;
